export interface BuildUrlResult {
  url: string | null
  invalid: boolean
}

export type UrlParam = readonly [key: string, value: string]

export function buildUrl(
  baseUrl: string,
  params: ReadonlyArray<UrlParam>,
): BuildUrlResult {
  const trimmed = baseUrl.trim()
  if (trimmed === '') return { url: null, invalid: true }

  let url: URL
  try {
    url = new URL(trimmed)
  } catch {
    return { url: null, invalid: true }
  }

  for (const [key, value] of params) {
    if (value === '') continue
    url.searchParams.set(key, value)
  }

  return { url: url.toString(), invalid: false }
}

export function isValidUrl(input: string): boolean {
  const trimmed = input.trim()
  if (trimmed === '') return false
  try {
    new URL(trimmed)
    return true
  } catch {
    return false
  }
}
